<template>
  <TsColumn class="block lg:hidden">
    <div
      data-testid="column-hamburger"
      @click="openMobileMenu"
    >
      <TsIcon
        class="hover:text-natural-light-grey cursor-pointer size-6"
        name="radix-icons:hamburger-menu"
        size="28"
        dataTestid="icon-hamburger"
      />
    </div>

    <TsDrawer
      v-model:visible="menuStore.show_mobile_menu_drawer"
      data-testid="previewDirectory"
      position="right"
      appendClass="w-[95%] h-full top-3 rounded-tl-lg rounded-bl-lg hide-scroll-bar px-0"
      content-class="p-0"
    >
      <template #content="{ hideDrawer }">
        <TsDrawerMobileMenu
          :header-links="rootStore.header_links"
          @close="hideDrawer()"
        />
      </template>
    </TsDrawer>
  </TsColumn>
</template>
<script setup lang="ts">
const TsDrawer = defineAsyncComponent(() => import('~/components/organisms/TsDrawer.vue'));
const TsDrawerMobileMenu = defineAsyncComponent(() => import('~/components/organisms/TsDrawerMobileMenu.vue'));

type Props = {
  dataTestid?: string;
};
const props = withDefaults(defineProps<Props>(), {});

const menuStore = useMenuStore();
const rootStore = useRootStore();

function openMobileMenu() {
  menuStore.show_mobile_menu_drawer = true;
  menuStore.current_menu = "main-menu";
}
</script>
